import '@/polyfills';
import '@/handlers';
import map from 'staticfile'
// typeof Promise == "object" && console.info("forced promise");
import htmlComponent from 'htmlcomponent'

htmlComponent.setStaticLoader(map);
htmlComponent.query(document);
